import { defineMessages } from 'react-intl';

export default defineMessages({
  back: {
    id: 'headerBar.backToExperiences',
    defaultMessage: 'Back to experiences',
  },
});
